import styled from "@emotion/styled";
import theme from "../../theme";

const HR = styled.hr`
  border-top: solid 1px ${theme.colors.accent};
`;

export default HR;
